import { Link } from "react-router-dom";
import { categoryData } from "@/data/categoryData";
import { directoryEntries } from "@/data/directoryData";

const SiteFooter = ({ onSuggest }: { onSuggest: () => void }) => {
  const categories = categoryData;

  return (
    <footer className="border-t border-border bg-card">
      <div className="container max-w-6xl px-4 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Column 1: About */}
          <div>
            <h3 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              NERC CIP Ecosystem
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed mb-4">
              The definitive directory of NERC CIP regulators, products, consultants, training providers, and compliance resources.
            </p>
            <p className="text-xs text-muted-foreground">
              {directoryEntries.length} entries across {categories.length} categories
            </p>
            <div className="mt-4">
              <a
                href="https://www.serviceaide.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Sponsored by <span className="font-bold text-primary">serviceaide.com</span>
              </a>
            </div>
          </div>

          {/* Column 2: Pages */}
          <div>
            <h3 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Pages
            </h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-xs text-muted-foreground hover:text-primary transition-colors">Home — Directory</Link></li>
              <li><Link to="/what-is-nerc-cip" className="text-xs text-muted-foreground hover:text-primary transition-colors">What is NERC CIP?</Link></li>
              <li><Link to="/how-to-use" className="text-xs text-muted-foreground hover:text-primary transition-colors">How to Use This Directory</Link></li>
              <li><Link to="/cip-standards" className="text-xs text-muted-foreground hover:text-primary transition-colors">CIP Standards Index</Link></li>
              <li><Link to="/nerc-cip-consulting" className="text-xs text-muted-foreground hover:text-primary transition-colors">NERC CIP Consulting</Link></li>
            </ul>
          </div>

          {/* Column 3: Guides & Reports */}
          <div>
            <h3 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Guides & Reports
            </h3>
            <ul className="space-y-2">
              <li><Link to="/nerc-cip-2026-report" className="text-xs text-muted-foreground hover:text-primary transition-colors">2026 Trends Report</Link></li>
              <li><Link to="/nerc-cip-audit-guide" className="text-xs text-muted-foreground hover:text-primary transition-colors">Audit & Enforcement Guide</Link></li>
              <li><Link to="/nerc-cip-buying-guide" className="text-xs text-muted-foreground hover:text-primary transition-colors">Product & Consultant Buying Guide</Link></li>
              <li><Link to="/nerc-cip-low-impact" className="text-xs text-muted-foreground hover:text-primary transition-colors">Low-Impact BES Systems</Link></li>
              <li><Link to="/nerc-cip-insm" className="text-xs text-muted-foreground hover:text-primary transition-colors">Internal Network Security Monitoring</Link></li>
              <li><Link to="/nerc-cip-cloud-security" className="text-xs text-muted-foreground hover:text-primary transition-colors">Cloud & Third-Party Security</Link></li>
              <li><Link to="/nerc-cip-supply-chain" className="text-xs text-muted-foreground hover:text-primary transition-colors">Supply Chain Risk Management</Link></li>
              <li><Link to="/nerc-cip-grid-transformation" className="text-xs text-muted-foreground hover:text-primary transition-colors">Grid Transformation & Risk</Link></li>
            </ul>
          </div>

          {/* Column 4: Directory Categories */}
          <div>
            <h3 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Directory Categories
            </h3>
            <ul className="space-y-2">
              {categories.map((cat) => {
                const count = directoryEntries.filter((e) => e.category === cat.name).length;
                return (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-xs text-muted-foreground hover:text-primary transition-colors">
                      {cat.name} <span className="text-muted-foreground/50">({count})</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-[11px] text-muted-foreground font-mono">
            © {new Date().getFullYear()} NERC CIP Directory
          </span>
          <div className="flex items-center gap-4">
            <button
              onClick={onSuggest}
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Suggest an entry
            </button>
            <a
              href="https://www.serviceaide.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Sponsored by <span className="font-bold text-primary">serviceaide.com</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
